<template>
  <div class="card">
    <div class="card-header">
      <label class="az-content-label" style="text-transform: none">Reports</label>
    </div>

    <div class="card-body">
      <!-- Non-BGL funds: current reports -->
      <div v-if="!isBglFund">
        <div>
          <a
            href="#"
            @click.prevent="getReport(report1, 'UnrealisedCapital')"
            :class="{ 'is-loading': loadingKey === 'UnrealisedCapital' }"
          >
            <span class="tx-13">
              Unrealised Capital Gains Report
              <i :class="loadingKey === 'UnrealisedCapital' ? 'el-icon-loading' : 'el-icon-download'"></i>
            </span>
            <p class="tx-12 tx-gray-500">
              The investment gain or loss of assets that have not been sold, as at a specified date.
            </p>
          </a>
        </div>

        <div>
          <a
            href="#"
            @click.prevent="getReport(report2, 'RealisedCapital')"
            :class="{ 'is-loading': loadingKey === 'RealisedCapital' }"
          >
            <span class="tx-13">
              Realised Capital Gains Report
              <i :class="loadingKey === 'RealisedCapital' ? 'el-icon-loading' : 'el-icon-download'"></i>
            </span>
            <p class="tx-12 tx-gray-500">
              The investment gain or loss of assets that have been sold, as at a specified date.
            </p>
          </a>
        </div>

        <div>
          <a
            href="#"
            @click.prevent="getReport(report3, 'InvestmentIncome')"
            :class="{ 'is-loading': loadingKey === 'InvestmentIncome' }"
          >
            <span class="tx-13">
              Investment Income Detailed Report
              <i :class="loadingKey === 'InvestmentIncome' ? 'el-icon-loading' : 'el-icon-download'"></i>
            </span>
            <p class="tx-12 tx-gray-500">
              Detailed list of income earned and associated tax status.
            </p>
          </a>
        </div>

        <div>
          <a
            href="#"
            @click.prevent="getReport(report4, 'InvestmentReturns')"
            :class="{ 'is-loading': loadingKey === 'InvestmentReturns' }"
          >
            <span class="tx-13">
              Investment Returns
              <i :class="loadingKey === 'InvestmentReturns' ? 'el-icon-loading' : 'el-icon-download'"></i>
            </span>
            <p class="tx-12 tx-gray-500">
              The percentage investment return of your portfolio over a period of time Simple Dietz (Variant).
            </p>
          </a>
        </div>

        <div>
          <a
            href="#"
            @click.prevent="getReport(report5, 'AssetStrategy')"
            :class="{ 'is-loading': loadingKey === 'AssetStrategy' }"
          >
            <span class="tx-13">
              Asset Strategy Comparison
              <i :class="loadingKey === 'AssetStrategy' ? 'el-icon-loading' : 'el-icon-download'"></i>
            </span>
            <p class="tx-12 tx-gray-500">
              A comparision between the actual and asset allocation strategy selected for the fund.
            </p>
          </a>
        </div>

        <div>
          <a
            href="#"
            @click.prevent="getReport(report6, 'InvestmentAllocation')"
            :class="{ 'is-loading': loadingKey === 'InvestmentAllocation' }"
          >
            <span class="tx-13">
              Investment Allocation
              <i :class="loadingKey === 'InvestmentAllocation' ? 'el-icon-loading' : 'el-icon-download'"></i>
            </span>
            <p class="tx-12 tx-gray-500">
              A breakdown of what the portfolio is invested in by the type of asset.
            </p>
          </a>
        </div>
      </div>

      <!-- BGL funds: only show Investment Summary & Movement reports -->
      <div v-else>
        <div>
          <a
            href="#"
            @click.prevent="getReport(reportSummaryBGL, 'InvestmentSummaryBGL')"
            :class="{ 'is-loading': loadingKey === 'InvestmentSummaryBGL' }"
          >
            <span class="tx-13">
              Investment Summary Report
              <i :class="loadingKey === 'InvestmentSummaryBGL' ? 'el-icon-loading' : 'el-icon-download'"></i>
            </span>
            <p class="tx-12 tx-gray-500">
              Summary of current investments and balances.
            </p>
          </a>
        </div>

        <div>
          <a
            href="#"
            @click.prevent="getReport(reportMovementBGL, 'InvestmentMovementBGL')"
            :class="{ 'is-loading': loadingKey === 'InvestmentMovementBGL' }"
          >
            <span class="tx-13">
              Investment Movement Report
              <i :class="loadingKey === 'InvestmentMovementBGL' ? 'el-icon-loading' : 'el-icon-download'"></i>
            </span>
            <p class="tx-12 tx-gray-500">
              Movements in investments over the selected period.
            </p>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { downloadReport } from '@/utils/classReports';

export default {
  name: 'reports',
  data() {
    return {
      loadingKey: null, // which report is loading (string) or null
      report1: this.$route.params.fund_code + '+UnrealisedCapital',
      report2: this.$route.params.fund_code + '+RealisedCapital',
      report3: this.$route.params.fund_code + '+InvestmentIncome',
      report4: this.$route.params.fund_code + '+InvestmentReturns',
      report5: this.$route.params.fund_code + '+AssetStrategy',
      report6: this.$route.params.fund_code + '+InvestmentAllocation',
      
      isBglFund: localStorage.getItem('is_bgl_fund') === 'true',
      reportSummaryBGL: this.$route.params.fund_code + '+InvestmentSummaryBGL',
      reportMovementBGL: this.$route.params.fund_code + '+InvestmentMovementBGL',
    };
  },
  methods: {
    async getReport(report, key) {
      if (this.loadingKey) return;          // prevent parallel downloads
      this.loadingKey = key;                // show spinner on this one

      try {
        await downloadReport({
          report,
          api: this.$api.funddashboard_api,
          fallbackName: 'report.pdf',
        });
      } catch (err) {
        console.error('Failed to fetch or display report:', err);
      } finally {
        this.loadingKey = null;             // restore icon
      }
    },
  },
};
</script>

<style scoped>
/* Dim and disable only the active item while loading */
.is-loading {
  pointer-events: none;
  opacity: .7;
}
</style>
